import { jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { theme } from "../../../foundations/theme.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import { memo } from "react";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import { styled } from "@mui/material";
import { CaretDownSolid as e$1 } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/caret-down-solid.es.es.js";
import { CaretUpSolid as e } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/caret-up-solid.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { CustomArrowButtonDirections } from "../interfaces/custom-arrow-button.interface.es.js";
import { BorderRadius } from "../../../foundations/border-radius.es.js";
import { CursorStyle } from "../../../foundations/cursor-style.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
const customBorderStyle = `1px solid ${theme.palette.border.main}`;
const customBorderRadius = ` ${BorderRadius.soft} ${BorderRadius.soft} `;
const zeroBorderRadius = ` ${BorderRadius.none} ${BorderRadius.none} `;
const defaultHoverStyle = {
  backgroundColor: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  cursor: CursorStyle.pointer,
  color: theme.palette.primary.contrastText
};
const disabledHoverStyle = {
  cursor: CursorStyle.notAllowed
};
const CustomButton = styled("button")(({
  direction,
  disabled
}) => {
  const hoverStyle = disabled ? disabledHoverStyle : defaultHoverStyle;
  let borderRadius = customBorderRadius + zeroBorderRadius;
  let borderTop;
  if (direction === CustomArrowButtonDirections.down) {
    borderRadius = zeroBorderRadius + customBorderRadius;
    borderTop = Displaying.none;
  }
  return {
    border: customBorderStyle,
    borderTop,
    borderRadius,
    padding: Spacing["250"],
    display: Displaying.flex,
    appearance: Displaying.none,
    alignItems: Alignment.center,
    justifyContent: Alignment.center,
    boxSizing: "border-box",
    background: theme.palette.background.default,
    color: theme.palette.action.active,
    fontSize: Spacing["650"],
    "&:hover": hoverStyle
  };
});
function CustomArrowButtonBuilder({
  onClick,
  direction,
  disabled,
  ...rest
}) {
  return /* @__PURE__ */ jsx(CustomButton, { onClick, direction, disabled, ...rest, children: direction === CustomArrowButtonDirections.up ? /* @__PURE__ */ jsx(e, { fontSize: Displaying.inherit }) : /* @__PURE__ */ jsx(e$1, { fontSize: Displaying.inherit }) });
}
const CustomArrowButton = memo(CustomArrowButtonBuilder);
export {
  CustomArrowButton
};
//# sourceMappingURL=custom-arrow-button.es.js.map
